// Deterministic color palette for chart slices.
//
// The Account-tab donuts now show every distinct expense_type / operative_type
// row, so the slice count is unbounded. We pick a hand-tuned ordered base
// palette of 12 distinct, accessible colors (matching the rest of the
// executive dashboard) and fall back to evenly-spaced HSL rotation once the
// list exceeds 12 entries — keeps adjacent slices visually distinct without
// repeating the base colors.

const BASE_PALETTE = [
  '#2a8d9c', // teal — primary
  '#e67e22', // orange
  '#4caf50', // green
  '#9b59b6', // purple
  '#f1c40f', // yellow
  '#3498db', // blue
  '#e74c3c', // red
  '#1abc9c', // mint
  '#34495e', // slate
  '#d35400', // burnt orange
  '#16a085', // dark teal
  '#8e44ad', // dark purple
]

export function paletteColor(index: number): string {
  if (index < BASE_PALETTE.length) return BASE_PALETTE[index]
  // Past the base palette: rotate hue by golden-ratio steps for separation,
  // and keep saturation/lightness fixed so the colors stay readable on white.
  const i = index - BASE_PALETTE.length
  const hue = (i * 137.508) % 360
  return `hsl(${hue.toFixed(0)}, 60%, 50%)`
}
